import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input';
import React from 'react';
import { useInputController } from '../hooks/useInputController';
import { useFormItemAccessibility } from '../item/useFormItemAccessibility';
import { useFormItemEnabled } from '../item/useFormItemEnabled';
const { TextArea } = Input;

export interface ITextAreaInputProps extends Omit<TextAreaProps, 'name'> {
  name: string;
}

/**
 * Campo per input area di testo.
 */
export function TextAreaInput(props: ITextAreaInputProps) {
  const { name, ...inputProps } = props;

  const { enabled, layoutEnabled } = useFormItemEnabled();

  const {
    field: { value, onChange, onBlur, ref },
  } = useInputController(name, { enabled });

  const accessibility = useFormItemAccessibility();

  return (
    <TextArea
      size="large"
      ref={ref}
      name={name}
      disabled={enabled === false || layoutEnabled === false}
      {...accessibility.attributes}
      {...inputProps}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
}
